define("settings/components/avatar-upload", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--user__avatar cNA--group__avatar" {{on "click" this.handleClick}}>
    <img class="cNA--group__avatar--img" src={{this.imageUrl}} />
    {{svg-jar "add-circle" class="o--icon--md o--icon--hl cSS--user__actionIcon"}}
  </div>
  
  <input accept="image/*" class="u--hide" id={{this.inputId}} type="file" {{on "change" this.handleFileChange}} />
  <canvas class="u--hide" height={{this.height}} id="avatarCanvas" width={{this.width}}></canvas>
  */
  {
    "id": "x38/wXB/",
    "block": "[[[11,0],[24,0,\"o--user__avatar cNA--group__avatar\"],[4,[38,0],[\"click\",[30,0,[\"handleClick\"]]],null],[12],[1,\"\\n  \"],[10,\"img\"],[14,0,\"cNA--group__avatar--img\"],[15,\"src\",[30,0,[\"imageUrl\"]]],[12],[13],[1,\"\\n  \"],[1,[28,[35,1],[\"add-circle\"],[[\"class\"],[\"o--icon--md o--icon--hl cSS--user__actionIcon\"]]]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[11,\"input\"],[24,\"accept\",\"image/*\"],[24,0,\"u--hide\"],[16,1,[30,0,[\"inputId\"]]],[24,4,\"file\"],[4,[38,0],[\"change\",[30,0,[\"handleFileChange\"]]],null],[12],[13],[1,\"\\n\"],[10,\"canvas\"],[14,0,\"u--hide\"],[15,\"height\",[30,0,[\"height\"]]],[14,1,\"avatarCanvas\"],[15,\"width\",[30,0,[\"width\"]]],[12],[13]],[],false,[\"on\",\"svg-jar\"]]",
    "moduleName": "settings/components/avatar-upload.hbs",
    "isStrictMode": false
  });
  let AvatarUploadComponent = _exports.default = (_class = class AvatarUploadComponent extends _component2.default {
    constructor() {
      super(...arguments);
      // The iOS app displays the group avatar larger than the web app:
      // iPhone 14 Pro: 120x120
      // iPad Pro 11":  160x160
      _defineProperty(this, "height", 320);
      _defineProperty(this, "width", 320);
      _defineProperty(this, "inputId", 'avatarInput');
      _initializerDefineProperty(this, "_newImageUrl", _descriptor, this);
    }
    get imageUrl() {
      return this._newImageUrl || this.args.defaultUrl;
    }
    handleClick() {
      document.querySelector(`#${this.inputId}`).click();
    }
    handleFileChange(_ref) {
      let {
        target: {
          files
        }
      } = _ref;
      const fileReader = new FileReader();
      fileReader.readAsDataURL(files[0]);
      fileReader.onload = () => {
        const image = new Image();
        image.src = fileReader.result;
        image.onload = () => {
          const canvas = document.querySelector('#avatarCanvas');
          const context = canvas.getContext('2d');
          const imageObj = new Image();
          imageObj.src = fileReader.result;
          imageObj.onload = () => {
            context.drawImage(imageObj, 0, 0, this.width, this.height);
            this._newImageUrl = canvas.toDataURL();
            this.args.addDataUrl(this.imageUrl);
          };
        };
      };
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_newImageUrl", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleFileChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleFileChange"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AvatarUploadComponent);
});